// import { Routes, Route, Navigate } from "react-router-dom";
// import DashboardLayout from "./components/Dashboard";
// import CompanyInfoForm from "./components/CompanyInfoForm";
// import CompanyDetails from "./components/CompanyDetails";
// import BuyerInfoForm from "./components/BuyerInfoForm";
// import BuyerDetails from "./components/BuyerDetails";
// import VoucherEntry from "./components/VoucherEntry";
// import BillingDetails from "./components/BillingDetails";
// import UploadPDF from "./components/UploadPDF";
// import ClearedList from "./components/ClearedList";
// import LoginPage from "./components/LoginPage";

// const App = () => {
//   return (
//     <Routes>
//       {/* <Route path="/" element={<LoginPage />} /> */}
//       <Route path="" element={<DashboardLayout />}>
//         <Route index element={<CompanyInfoForm />} />
//         <Route path="buyer" element={<BuyerInfoForm />} />
//         <Route path="company-details" element={<CompanyDetails />} />
//         <Route path="buyer-details" element={<BuyerDetails />} />
//         <Route path="voucher-entry" element={<VoucherEntry />} />
//         <Route path="billing-details" element={<BillingDetails />} />
//         <Route path="/upload-pdf" element={<UploadPDF />} />
//         <Route path="/cleared" element={<ClearedList />} />
//       </Route>
//     </Routes>
//   );
// };

// export default App;

// import { Routes, Route, Navigate } from "react-router-dom";
// import DashboardLayout from "./components/Dashboard";
// import CompanyInfoForm from "./components/CompanyInfoForm";
// import CompanyDetails from "./components/CompanyDetails";
// import BuyerInfoForm from "./components/BuyerInfoForm";
// import BuyerDetails from "./components/BuyerDetails";
// import VoucherEntry from "./components/VoucherEntry";
// import BillingDetails from "./components/BillingDetails";
// import UploadPDF from "./components/UploadPDF";
// import ClearedList from "./components/ClearedList";
// import LoginPage from "./components/LoginPage";
// import CreditDetails from "./components/CreditDetails";

// // 🔒 Protected Route
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem("token");
//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }
//   return children;
// };

// const App = () => {
//   return (
//     <Routes>
//       {/* Public login route */}
//       <Route path="/login" element={<LoginPage />} />

//       {/* Protected routes (only accessible if logged in) */}
//       <Route
//         path="/admin"
//         element={
//           <ProtectedRoute>
//             <DashboardLayout />
//           </ProtectedRoute>
//         }
//       >
//         <Route path="dashboard" element={<CompanyInfoForm />} />
//         <Route path="buyer" element={<BuyerInfoForm />} />
//         <Route path="company-details" element={<CompanyDetails />} />
//         <Route path="buyer-details" element={<BuyerDetails />} />
//         <Route path="voucher-entry" element={<VoucherEntry />} />
//         <Route path="billing-details" element={<BillingDetails />} />
//         <Route path="upload-pdf" element={<UploadPDF />} />
//         <Route path="cleared" element={<ClearedList />} />
//         <Route path="credit-details" element={<CreditDetails />} />
//       </Route>

//       {/* Redirect unknown routes to login */}
//       <Route path="*" element={<Navigate to="/login" replace />} />
//     </Routes>
//   );
// };

// export default App;

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import DashboardLayout from "./components/Dashboard";
import CompanyInfoForm from "./components/CompanyInfoForm";
import CompanyDetails from "./components/CompanyDetails";
import BuyerInfoForm from "./components/BuyerInfoForm";
import BuyerDetails from "./components/BuyerDetails";
import VoucherEntry from "./components/VoucherEntry";
import BillingDetails from "./components/BillingDetails";
import UploadPDF from "./components/UploadPDF";
import ClearedList from "./components/ClearedList";
import LoginPage from "./components/LoginPage";
import CreditDetails from "./components/CreditDetails";
import Dashboard1 from "./components/Dashboard1";
import SheetCutCalculator from "./components/SheetCutCalculator";
import WeightPriceCalc from "./components/WeightPriceCalc";
import ExpenseTracker from "./components/Expense";

// 🔒 Protected Route
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// 🔄 Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public login route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes (only accessible if logged in) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <DashboardLayout />
          
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard1 />} />
          <Route path="company-info" element={<CompanyInfoForm />} />
          <Route path="buyer" element={<BuyerInfoForm />} />
          <Route path="company-details" element={<CompanyDetails />} />
          <Route path="buyer-details" element={<BuyerDetails />} />
          <Route path="voucher-entry" element={<VoucherEntry />} />
          <Route path="billing-details" element={<BillingDetails />} />
          <Route path="upload-pdf" element={<UploadPDF />} />
          <Route path="cleared" element={<ClearedList />} />
          <Route path="credit-details" element={<CreditDetails />} />
          <Route path="calculator" element={<SheetCutCalculator />} />
          <Route path="calculator2" element={<WeightPriceCalc />} />
          <Route path="expense-tracker" element={<ExpenseTracker />} />
        </Route>

      

        {/* Redirect unknown routes to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

export default App;
